<template>
  <div class="form-field form-checklist"
       :rel="computedRelName"
       :class="wrapperClasses">

    <div class="form-label" v-show="label">{{ label }}</div>
    <div class="form-hint" v-show="hint">{{ hint }}</div>
    <div class="form-input">
      <div class="form-input-wrapper" :class="{'block': display == 'block'}">

        <label v-for="option in options" :title="option['id']">
          <input
              :name="computedInputName"
              :readonly="isReadonly"
              :disabled="isDisabled"
              :required="isRequired"
              :type="type"
              :value="option.id"
              :checked="isChecked(option.id)"
              @change="toggleValue(option.id)"/>

          <span>
              <span class="color" :style="{background: option['color'], borderColor: option['color']}">
                <i class="icon icon-icon_check"></i>
              </span>
              <strong>{{ option['name'] }}</strong>
              <p v-if="option['description']">{{ option['description'] }}</p>
          </span>
        </label>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      required: false
    },
    display: {
      type: [String, null],
      required: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: [Array, String, null],
      required: false
    },
    callback: {
      required: false
    },
    label: {
      default: null
    },
    hint: {
      default: null
    },
    multiple: {
      default: false
    },
  },
  data: function() {
    return {
      uniqueId: Math.random().toString(36).substr(2, 9)
    };
  },
  created: function() {
    this.type = this.isMultiple ? 'checkbox' : 'radio';
  },
  computed: {
    wrapperClasses: function() {
      return {
        'form-required': this.isRequired,
        'form-readonly': this.isReadonly,
        'form-disabled': this.isDisabled,
        'form-checklist-multiple': this.isMultiple
      };
    },
    computedRelName: function() {
      return this.name ? this.name : this.uniqueId;
    },
    computedInputName: function() {
      return this.name ? this.name : this.uniqueId;
    },
    isReadonly: function() {
      return this.readOnly && (this.readOnly == 'true' || this.readOnly == true) ? true : false
    },
    isDisabled: function() {
      return this.disabled && (this.disabled == 'true' || this.disabled == true) ? true : false
    },
    isRequired: function() {
      return this.required && (this.required == 'true' || this.required == true) ? true : false
    },
    isMultiple: function() {
      return this.multiple === true;
    }
  },
  methods: {
    isChecked: function (id) {
      if (!this.isMultiple) {
        console.log(this.computedRelName, this.value, id, String(this.value) === String(id));
        return String(this.value) === String(id);
      }
      return Array.isArray(this.value) ? this.value.map(String).includes(String(id)) : false;
    },
    toggleValue: function(id) {

      let newValue = null;

      if( !this.isMultiple )
      {
        newValue = id;
      }else{

        newValue = Array.isArray(this.value) ? this.value.slice() : [];
        if (newValue.includes(id)) {
          newValue = newValue.filter(val => val !== id);
        } else {
          newValue.push(id);
        }

      }

      this.$emit('input', newValue);

      if (this.callback) {
        this.callback(newValue);
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/form/Checklist.vue